import { isSameDate, isSameMonth, isSameYear } from './index';

/**
 * Check if two given dates are at the daydate
 */
export default function isSameDayDate(a, b) {
  return isSameDate(a, b) && isSameMonth(a, b) && isSameYear(a, b);
}
